import dayjs from 'dayjs';
import { authClient } from '../api_actions/auth_index';
import {
    redirect,
    useNavigate,
} from 'react-router-dom'

import { useCustomerLogoStore, useCustomerNameStore, useRoleNameStore } from '../store';

const formatDate = (value) => {
  return !!value ? new Date(value).toISOString().slice(0, 10) : "";
}

const getIPAddressFromURL = (url) => {
  if (url == "" || url == null || url == undefined)
    return "";

  const regex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;
  const matches = url.match(regex);
  if (matches && matches.length > 0) {
    return matches[0];
  } else {
    return "";
  }
}

const capitalizeFirstLetter = (str) => {
  return str.split(/(\s|-)/)
    .map(word => {
      if (word.match(/[\s-]/)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
}

export default function humanizeString(str) {
  if (!str && str !== 0) return ''; // Handle 0 explicitly
  //console.log("STRING: ", str)
  
  return String(str) // Convert to string
    .replace(/_/g, ' ')
    .split(' ')
    .join(' ');
}

const isSameOrBeforeCurrentDate = (givenDate) => {
  // Get the current date
  const now = new Date();
  now.setHours(0, 0, 0, 0); // Set the current date to midnight

  // Convert the given date to a Date object if it's a string
  const date = new Date(dayjs.utc(givenDate * 1000).format('MM/DD/YYYY'));
  date.setHours(0, 0, 0, 0); // Set the given date to midnight

  // console.log(date.getTime(), now.getTime())

  // Compare the given date with the current date
  return date.getTime() <= now.getTime();
}


const configureTableFilters = (data) => {
  const transformedData = data.map(item => ({
      text: capitalizeFirstLetter(item.text?.replace(/_/g, ' ').replace(/\s(\.)/g, ',')),
      value: item.value
  }));
  return transformedData
}

export const dateSorter = (key) => (a, b) => {
  const tA = new Date(a[key]).getTime();
  const tB = new Date(b[key]).getTime();

  if (isNaN(tA) && isNaN(tB)) return 0;
  if (tA === -1000 || isNaN(tA)) return -1;
  if (tB === -1000 || isNaN(tB)) return 1;
  return tA - tB;
};

export function makeSetValue(rowKey, fieldName) {
  return function(newValue) {
    setData(prev =>
      prev.map(row =>
        row.key === rowKey
          ? { ...row, [fieldName]: newValue }
          : row
      )
    );
  };
}

export const isBeforeToday = (isoString) => {
  const date = new Date(isoString);

  // Check for the default Unix -1 value
  if (date.getTime() === -1000) {
    return false; // treat as default / invalid
  }

  const today = new Date();
  date.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return date < today;
};

export const parseDateForUI = (isoString) => {
  if (!isoString) return null;
  const timestamp = new Date(isoString).getTime();
  // Treat Unix -1 as "no value"
  if (timestamp === -1000) return null;

  return dayjs(isoString);
};

export const useLogout = () => {
  const navigate = useNavigate();

      const updateCustomerLogo = useCustomerLogoStore(state => state.updateCustomerLogo);
      const updateCustomerName = useCustomerNameStore(state => state.updateCustomerName)
      //const isLogin = useAuthStore(state => state.isLogin);
      //const updateAuth = useAuthStore(state => state.updateAuth);
      const updateRoleName = useRoleNameStore(state => state.updateRoleName)

  const logout = async () => {
    const token = localStorage.getItem("token");
    try {
      await authClient.post("auth/logout", { token });
    } catch (err) {
      console.log(err);
    }
    localStorage.removeItem("token");
    updateCustomerLogo("")
    updateCustomerName("");
    updateRoleName("")
    
    navigate("/login");
  };

  return logout;
};

function formatSeconds(totalSeconds) {
  // Handle negative values
  if (totalSeconds < 0) {
    return "0h 0m 0s";
  }
  
  // Calculate hours, minutes, and seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  
  // Option 1: Readable format (e.g., "2h 15m 30s")
  return `${hours}h ${minutes}m ${seconds}s`;
}

function formatNs(ns) {
const ms = ns / 1_000_000;
    
    if (ms >= 1000) {
        return `${(ms / 1000).toFixed(2)} s`;  // Convert to seconds
    } else if (ms >= 1) {
        return `${ms.toFixed(2)} ms`;
    } else if (ms >= 0.001) {
        return `${(ns / 1000).toFixed(2)} μs`;  // Microseconds
    } else {
        return `${ns} ns`;  // Keep as nanoseconds
    }
}

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // includes MIME type prefix
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export {
  formatDate,
  getIPAddressFromURL,
  capitalizeFirstLetter,
  isSameOrBeforeCurrentDate,
  configureTableFilters,
  formatNs,
  toBase64,
  formatSeconds
}